import { Typography, Stack, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../../../components/button/CustomButton';
import { ReactComponent as ArrowRightIcon } from '../../../../assets/icons/project-icons/ArrowRightIcon.svg';
import { LAYOUT_DEFAULTS } from '../../../../utils/constants';
import { getPublicImageUrl } from '../../../../utils/helpers';
import { EnumPublicPagesImage } from '../../../../utils/enums';

const LetSponaHandleIt = () => {
  const navigate = useNavigate();

  return (
    // main row
    <Stack
      spacing={{ xs: 0, lg: 4 }}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ ...LAYOUT_DEFAULTS, mb: 10, mt: { xs: -5, sm: 0 } }}
    >
      {/* left column */}
      <Stack spacing={3}>
        <Stack spacing={1} display={{ xs: 'none', md: 'block' }}>
          <Typography sx={{ typography: { xs: 'publicHeading5', lg: 'publicHeading4' } }}>
            Who can you find on Spona?
          </Typography>

          <Typography variant="publicBody4Regular" color="common.black">
            Looking for a creative pro, a technical expert, or someone to manage execution? We’ve
            got you covered:
          </Typography>
        </Stack>
        <Box
          src={getPublicImageUrl(EnumPublicPagesImage.LetSponaHandleItNew)}
          component="img"
          sx={{ display: { xs: 'none', md: 'block' }, ml: '-30px !important' }}
          alt="Illustration of multiple cards representing Spona sellers in different colors"
        />
      </Stack>

      {/* right column */}
      <Stack spacing={{ xs: 3, md: 6 }} sx={{ maxWidth: { xs: '100%', lg: '60%' } }}>
        <Typography sx={{ typography: { xs: 'publicHeading4', lg: 'publicHeading3' } }}>
          Leave it to Spona
        </Typography>

        <Stack spacing={2}>
          <Typography variant="publicBody2Regular" color="common.black">
            🔹 Talk to a Spona Advisor
          </Typography>

          <Box
            src={getPublicImageUrl(EnumPublicPagesImage.LetSponaHandleItSmall)}
            component="img"
            sx={{ display: { xs: 'block', md: 'none' } }}
            alt="Illustration of multiple cards representing Spona sellers in different colors"
          />

          <Typography variant="publicBody4Regular" color="common.black">
            Tell us about your project—what you need, your timeline, your budget, and the type of
            expertise you're looking for.
          </Typography>
        </Stack>

        <Stack spacing={2}>
          <Typography variant="publicBody2Regular" color="common.black">
            🔹 We’ll help you find the right match 
          </Typography>

          <Typography variant="publicBody4Regular" color="common.black">
            Your advisor submits your brief and taps into our community of 1,000+ vetted digital
            professionals to shortlist the best candidates for your needs.
          </Typography>
        </Stack>

        <Stack spacing={2}>
          <Typography variant="publicBody2Regular" color="common.black">
            🔹 You choose and start 
          </Typography>

          <Typography variant="publicBody4Regular" color="common.black">
            Review your options, choose the expert you like best, and get your project
            underway—fast, simple, and fully supported by Spona.
          </Typography>
        </Stack>

        <CustomButton
          onClick={() => navigate('./spona-connect')}
          sx={{ maxWidth: 'fit-content' }}
          endIcon={<ArrowRightIcon fill="#fff" />}
        >
          Join Spona Connect
        </CustomButton>
      </Stack>
    </Stack>
  );
};

export default LetSponaHandleIt;
